export function setAccount({dispatch, state}, account) {
  dispatch('SET_ACCOUNT', account)
}

export function setWebSocketConnected ({dispatch, state}, bool) {
  dispatch('SET_WEBSOCKET_CONNECTED', bool)
}



// WEBPACK FOOTER //
// ./vuex/actions.js